export const apiSettingsCardSx = {
  container: {
    width: '100%',
    p: 2.5,
    borderRadius: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: '0.95rem',
    lineHeight: 1.4,
  },
  description: {
    fontSize: '0.8125rem',
    lineHeight: 1.5,
  },
  label: {
    fontWeight: 500,
    fontSize: '0.8125rem',
    minWidth: 120,
    flexShrink: 0,
  },
  link: {
    fontSize: '0.8125rem',
  },
  button: {
    minWidth: 120,
    textTransform: 'none',
    fontSize: '0.8125rem',
  },
  input: {
    fontSize: '0.8125rem',
  },
};
